import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUsersGroup = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M9.16 19.566c-.895 0-1.436-.644-1.474-1.54 0-1.826 1.782-2.456 4.467-2.477 2.69.028 4.476.658 4.467 2.476-.044.897-.581 1.54-1.475 1.54zM12.153 13.234a2.335 2.335 0 1 0 0-4.67 2.335 2.335 0 0 0 0 4.67Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M6.71 10.885c-2.23.017-3.71.54-3.71 2.056.032.745.48 1.28 1.224 1.28h2.887M17.29 10.885c2.23.017 3.71.54 3.71 2.056-.032.745-.48 1.28-1.224 1.28h-2.887"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M6.445 8.313a1.939 1.939 0 1 0 0-3.877 1.939 1.939 0 0 0 0 3.877ZM17.555 8.313a1.939 1.939 0 1 1 0-3.878 1.939 1.939 0 0 1 0 3.878Z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUsersGroup);
export default ForwardRef;
